import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import userSlice from 'store/user';
import applicationSlice from 'store/application';
import agencySlice from './agency';
import manageSlice from './manager';

const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    application: applicationSlice.reducer,
    agency: agencySlice.reducer,
    manager: manageSlice.reducer,
  },
});

type RootState = ReturnType<typeof store.getState>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
